import { DashboardRepositoryInterface } from '../../../data/contracts/Dashboard';
import { DashboardDataMapper } from '../../../data/mappers/Dashboard';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { Dashboard } from '../../../entities/Dashboard';

export class DashboardApiRepository implements DashboardRepositoryInterface {
  private apiService: ApiService;
  private mapper: DashboardDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: DashboardDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getDashboardData(rows: number): Promise<Dashboard> {
    const headers = new Map<string, string>();
    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.dashboard(),
      {
        limit: rows,
      },
      null,
      headers
    );
    return this.mapper.convertListDataDasboard(dataResponse);
  }
}
